import {ChangeDetectorRef, Component, NgModule, OnInit} from '@angular/core';
import {InstallModel} from '../../../_models/CapaModels/install.model';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {AuthenticationService} from '../../../_services/authentication.service';
import {Router} from '@angular/router';
import {ApiCapaService} from '../../../_services/apiCapa.service';
import {environment} from '../../../../environments/environment';
import {BaseModel} from '../../../_models/CapaModels/Base.model';
import {BaseLogModel} from '../../../_models/CapaModels/BaseLog.model';
import {UpperCasePipe} from '@angular/common';

@Component({
  selector: 'app-license-view',
  templateUrl: './license-view.component.html',
  styleUrls: ['./license-view.component.css']
})
export class LicenseViewComponent implements OnInit {

  install: InstallModel = new InstallModel();
  bases: BaseModel[];
  nbTotalElements: number;

  public nbCreditsToAdd = 0;

  public baseToInteract: BaseModel = null;
  IDInstall = this.router.url.split('/')[4];
  page: number = 1;
  nbElementsPerPage: number = 9;
  credit: string;
  searchEnabled: boolean = false;

  constructor(private oauthService: OAuthService, private cdRef: ChangeDetectorRef, private authenticationService: AuthenticationService,
              private router: Router, private ApiClient: ApiCapaService) { }

    ngOnInit() {
        this.ApiClient.get('Installs/' + this.IDInstall, environment.capaApiVersionDefault).subscribe(install => {
            this.install = install;
            this.getPagedBases();
        });
    }

    showSearchBar() {
      const searchBar = document.getElementById('search-bar-div');
      this.searchEnabled = !this.searchEnabled;
      if (this.searchEnabled) {
        searchBar.style.height = '40px';
      } else {
        searchBar.style.height = '0';
      }
    }

    getPagedBases(page: number = 1) {
        // @ts-ignore
        let idBase: string = document.getElementById('base-search-bar').value;
        idBase = idBase.toUpperCase();

        const queryObject = {
          pageNumber: page,
          numberOfRows: this.nbElementsPerPage,
          orderBy: '',
          parameters: {
              IDInstall: this.install.idInstall,
              IDBase: '%' + idBase + '%'
          }
      };

      this.ApiClient.post('Bases/paged-list', queryObject).subscribe(response => {
          this.bases = response['entities'];
          this.nbTotalElements = response['infos'][0]['count'];
      });
    }

    generateCredits() {
      const creditsData = {
        'IDInstall': this.IDInstall,
        'IDBase': this.baseToInteract.idBase,
        'Value': this.nbCreditsToAdd
      };

      this.ApiClient.post('Bases/generate-credit', JSON.stringify(creditsData)).subscribe(creditCode => {
         this.credit = creditCode;
         this.nbCreditsToAdd = 0;
      });
    }

  syncAllBases() {
      const baseLogs: BaseLogModel[] = [];
      for (const base of this.bases) {
          const newBaseLog: BaseLogModel = new BaseLogModel(base.idBase, 0, 'SYNCALL');
          baseLogs.push(newBaseLog);
      }
      this.ApiClient.post('BaseLogs/bulk-insert', baseLogs).subscribe(result => {
      });
  }

  syncBase(Base: BaseModel) {
      const baseLog = new BaseLogModel(Base.idBase, 0, 'SYNCALL');
      this.ApiClient.post('BaseLogs/upsert', baseLog).subscribe(result => {
          this.baseToInteract = null;
      });
  }

  // Permet de passer la base à la modal de confirmation de suppression
  setBaseToInteract(base: BaseModel) {
      this.baseToInteract = base;
  }

  // Supprime une base
  deleteBase(Base: BaseModel) {
    this.ApiClient.delete('Bases', Base).subscribe(result => {
      if (result === 1) {
          const itemIndex = this.bases.indexOf(Base);
          this.bases.splice(itemIndex, 1);
          this.baseToInteract = null;
      }
    });
  }

  // Supprime une license
  deleteInstall() {
    this.ApiClient.delete('Installs', this.install).subscribe( result => {
        if (result === 1) {
            this.router.navigate(['capa/license/list']);
        }
    });
  }

    // Redirige vers la page des résulats d'une install
    goToResults(license: InstallModel) {
        this.router.navigate(['capa/result/list', license.idInstall]);
    }
}
